import React from 'react'
import { Route, Switch } from 'react-router-dom'

import RoleGuard from '../../components/RoleGuard'
import { LANDING_PAGES_IMPORT_ROLES } from '../../constants/roles'
import LandingPagesExportsList from './LandingPagesExportsList'
import LandingPagesImportDetail from './LandingPagesImportDetail'
import LandingPagesManageDataList from './LandingPagesManageDataList'

export default () => {
    return {
        routes: [
            {
                path: '/landing-pages-export',
                render: ({ match }) => (
                    <Switch>
                        <Route path={`${match.url}`} exact component={LandingPagesExportsList} />
                    </Switch>
                ),
            },
            {
                path: '/manage-landing-pages-data/:id',
                exact: true,
                render: ({ match }) => (
                    <RoleGuard roles={LANDING_PAGES_IMPORT_ROLES}>
                        <Switch>
                            <Route path={match.path} exact component={LandingPagesImportDetail} />
                        </Switch>
                    </RoleGuard>
                ),
            },
            {
                path: '/manage-landing-pages-data',
                exact: true,
                render: ({ match }) => (
                    <RoleGuard roles={LANDING_PAGES_IMPORT_ROLES}>
                        <Switch>
                            <Route path={match.path} exact component={LandingPagesManageDataList} />
                        </Switch>
                    </RoleGuard>
                ),
            },
        ],
    }
}